import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { filter } from 'rxjs/operators';
import { EventMessage, EventType, AuthenticationResult, AccountInfo } from '@azure/msal-browser';
import { BehaviorSubject, Observable } from 'rxjs';
import { protectedResources } from '../auth-config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private readonly loggedIn = new BehaviorSubject<boolean>(false);
  private currentUser: AccountInfo | null = null;

  constructor(
    private readonly msalService: MsalService,
    private readonly msalBroadcastService: MsalBroadcastService
  ) {

    // Handle login success event
    this.msalBroadcastService.msalSubject$
      .pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS))
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);
        this.setLoginDisplay();
      });

    this.setLoginDisplay();
  }

  login(): void {
    this.msalService.loginRedirect();
  }

  logout(): void {
    this.msalService.logoutRedirect({
      postLogoutRedirectUri: '/',
    });
  }

  get isLoggedIn(): Observable<boolean> {
    return this.loggedIn.asObservable();
  }

  get activeAccount(): AccountInfo | null {
    return this.msalService.instance.getActiveAccount();
  }

  private setLoginDisplay(): void {
    const account = this.msalService.instance.getAllAccounts()[0] || null;
    this.msalService.instance.setActiveAccount(account);
    this.loggedIn.next(!!account);
    this.currentUser = account;
  }

  getUserName(): string | null {
    return this.currentUser?.name ?? null;
  }

  getUserEmail(): string | null {
    return this.currentUser?.username ?? null;
  }
  async acquireAccessToken(): Promise<string> {
    const account = this.msalService.instance.getActiveAccount();

    if (!account) {
      this.login();
      throw new Error('No active account');
    }

    try {
      const response = await this.msalService.instance.acquireTokenSilent({
        account,
        scopes: protectedResources.functionApi.scopes
      });

      return response.accessToken;
    } catch (error) {

      // If silent fails → force redirect
      await this.msalService.instance.acquireTokenRedirect({
        scopes: protectedResources.functionApi.scopes
      });

      throw error;
    }
  }
}
